import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.match";
import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module media-embed/automediaembed
 */
import MediaEmbedEditing from "./mediaembedediting";
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Clipboard from '@ckeditor/ckeditor5-clipboard/src/clipboard';
import LiveRange from '@ckeditor/ckeditor5-engine/src/model/liverange';
import LivePosition from '@ckeditor/ckeditor5-engine/src/model/liveposition';
import Undo from '@ckeditor/ckeditor5-undo/src/undo';
import global from '@ckeditor/ckeditor5-utils/src/dom/global';
import { insertMedia } from "./utils";
var URL_REGEXP = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;
/**
 * The auto-media embed plugin. It recognizes media links in the pasted content and embeds
 * them shortly after they are injected into the document.
 *
 * @extends module:core/plugin~Plugin
 */

var AutoMediaEmbed =
/*#__PURE__*/
function (_Plugin) {
  _inherits(AutoMediaEmbed, _Plugin);

  _createClass(AutoMediaEmbed, null, [{
    key: "requires",

    /**
     * @inheritDoc
     */
    get: function get() {
      return [Clipboard, Undo];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'AutoMediaEmbed';
    }
    /**
     * @inheritDoc
     */

  }]);

  function AutoMediaEmbed(editor) {
    var _this;

    _classCallCheck(this, AutoMediaEmbed);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AutoMediaEmbed).call(this, editor));
    /**
     * The paste–to–embed `setTimeout` ID. Stored as a property to allow
     * cleaning of the timeout.
     *
     * @private
     * @member {Number} #_timeoutId
     */

    _this._timeoutId = null;
    /**
     * The position where the `<media>` element will be inserted after the timeout,
     * determined each time the new content is pasted into the document.
     *
     * @private
     * @member {module:engine/model/liveposition~LivePosition} #_positionToInsert
     */

    _this._positionToInsert = null;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(AutoMediaEmbed, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor;
      var modelDocument = editor.model.document; // We need to listen on `Clipboard#inputTransformation` because we need to save positions of selection.
      // After pasting, the content between those positions will be checked for a URL that could be transformed
      // into media.

      this.listenTo(editor.plugins.get(Clipboard), 'inputTransformation', function () {
        var firstRange = modelDocument.selection.getFirstRange();
        var leftLivePosition = LivePosition.fromPosition(firstRange.start);
        leftLivePosition.stickiness = 'toPrevious';
        var rightLivePosition = LivePosition.fromPosition(firstRange.end);
        rightLivePosition.stickiness = 'toNext';
        modelDocument.once('change:data', function () {
          _this2._embedMediaBetweenPositions(leftLivePosition, rightLivePosition);

          leftLivePosition.detach();
          rightLivePosition.detach();
        }, {
          priority: 'high'
        });
      });
      editor.commands.get('undo').on('execute', function () {
        if (_this2._timeoutId) {
          global.window.clearTimeout(_this2._timeoutId);

          _this2._positionToInsert.detach();

          _this2._timeoutId = null;
          _this2._positionToInsert = null;
        }
      }, {
        priority: 'high'
      });
    }
    /**
     * Analyzes the part of the document between provided positions in search for a URL representing media.
     * When the URL is found, it is automatically converted into media.
     *
     * @protected
     * @param {module:engine/model/liveposition~LivePosition} leftPosition Left position of the selection.
     * @param {module:engine/model/liveposition~LivePosition} rightPosition Right position of the selection.
     */

  }, {
    key: "_embedMediaBetweenPositions",
    value: function _embedMediaBetweenPositions(leftPosition, rightPosition) {
      var _this3 = this;

      var editor = this.editor;
      var mediaRegistry = editor.plugins.get(MediaEmbedEditing).registry; // TODO: Use marker instead of LiveRange & LivePositions.

      var urlRange = new LiveRange(leftPosition, rightPosition);
      var walker = urlRange.getWalker({
        ignoreElementEnd: true
      });
      var url = '';
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = walker[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var node = _step.value;

          if (node.item.is('textProxy')) {
            url += node.item.data;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      url = url.trim(); // If the URL does not match to universal URL regexp, let's skip that.

      if (!url.match(URL_REGEXP)) {
        return;
      } // If the URL represents a media, let's use it.


      if (!mediaRegistry.hasMedia(url)) {
        return;
      }

      var mediaEmbedCommand = editor.commands.get('mediaEmbed'); // Do not anything if media element cannot be inserted at the current position (#47).

      if (!mediaEmbedCommand.isEnabled) {
        return;
      } // Position won't be available in the `setTimeout` function so let's clone it.


      this._positionToInsert = LivePosition.fromPosition(leftPosition); // This action mustn't be executed if undo was called between pasting and auto-embedding.

      this._timeoutId = global.window.setTimeout(function () {
        editor.model.change(function (writer) {
          _this3._timeoutId = null;
          writer.remove(urlRange);
          var insertionPosition; // Check if position where the media element should be inserted is still valid.
          // Otherwise leave it as undefined to use document.selection - default behavior of model.insertContent().

          if (_this3._positionToInsert.root.rootName !== '$graveyard') {
            insertionPosition = _this3._positionToInsert;
          }

          insertMedia(editor.model, url, insertionPosition);

          _this3._positionToInsert.detach();

          _this3._positionToInsert = null;
        });
      }, 100);
    }
  }]);

  return AutoMediaEmbed;
}(Plugin);

export { AutoMediaEmbed as default };